import { C, t } from '../constants/dashboardConstants';

/**
 * 사이드바 상단의 내 프로필 (이름 · 역할 · 사진).
 *
 * 배우·제작사 사이드바가 같은 모양을 쓰므로 한곳에 둔다.
 *
 * 사진은 원을 꽉 채우고, 기본 아이콘만 잘리지 않게 안쪽에 맞춘다.
 * 예전에는 둘 다 고정 픽셀(40px·26px)에 여백을 줘서 원 안에 작게 떠 있었다.
 */
export default function SidebarProfile({ src, name, role, isDefaultImage, size = 52 }) {
  return (
    <div
      className="sidebar-profile"
      data-testid="sidebar-profile"
      // 여백은 CSS에서 화면 폭에 따라 조정한다
      style={{ display: 'flex', alignItems: 'center', gap: '14px', minWidth: 0, flex: 1 }}
    >
      <div style={{
        width: size, height: size, aspectRatio: '1 / 1', borderRadius: '50%',
        flexShrink: 0, overflow: 'hidden',
        // 기본 아이콘은 회색 배경 위에, 실제 사진은 사진이 배경을 덮는다
        background: isDefaultImage ? C.g200 : C.white,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <img
          src={src}
          alt={name || '프로필'}
          style={isDefaultImage
            ? { width: '52%', height: '52%', objectFit: 'contain', display: 'block' }
            : { width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </div>

      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{
          ...t('20px', 600, C.bk),
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {name || '—'}
        </div>
        <div style={t('14px', 400, C.g400)}>{role}</div>
      </div>
    </div>
  );
}
